import React from 'react';
import { classNames } from '../../utils/style';

export const Box = ({ className, children }: any) => {
  return (
    <div className={classNames('PricingBox rounded-18 bg-white p-24 my-16', className)}>
      {children}
    </div>
  );
};
